import { OntarioObstetricalFileClickableTextContext } from "@/Common/Models/UI/ClickableTextContext";
import { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";
import { OntarioObstetricalFileFieldLimits } from "@/Patient/Components/MedicalNote/ObstetricalFile/Form/Ontario/OntarioObstetricalFileFieldLimits";

class OntarioObstetricalFileRecommendedImmuniprophylaxis extends BaseOntarioObstetricalFileSubSection<BaseOntarioObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const recomended = this.props.form.Opr3.RecommendedImmuniprophylaxis;
        const otherPostPartumVaccineDiscussedId = "RecommendedImmuniprophylaxis_OtherPostPartumVaccineDiscussed";

        return (
            <div className="section border border-top">
                {this.renderSubTitle("ObstetricalFile_RecommendedImmunoprophylaxisLabel")}
                <div className="row margin-md-top">
                    <div className="col-md-2">
                        {this.controlRenderer.renderCheckbox(
                            "ObstetricalFile_RdDNegLabel",
                            recomended.NegativeBloodRhesus,
                            value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.NegativeBloodRhesus = value),
                            "margin-xs-bottom",
                            "text-bold"
                        )}
                        {this.renderSimpleField(
                            "ObstetricalFile_RdDIGGivenLabel",
                            this.controlRenderer.renderDateSelector({
                                value: recomended.RhesusImmuneGlobulingGivenDate,
                                onChange: value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.RhesusImmuneGlobulingGivenDate = value),
                                id: "RecommendedImmuniprophylaxis_RhesusImmuneGlobulingGivenDate",
                                className: "width-100"
                            }),
                            "margin-xs-bottom"
                        )}
                        {this.renderSimpleField(
                            "ObstetricalFile_AdditionalDoseGivenLabel",
                            this.controlRenderer.renderDateSelector({
                                value: recomended.AdditionalDoseRhesusImmuneGlobulingGivenDate,
                                onChange: value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.AdditionalDoseRhesusImmuneGlobulingGivenDate = value),
                                id: "RecommendedImmuniprophylaxis_AdditionalDoseRhesusImmuneGlobulingGivenDate",
                                className: "width-100"
                            })
                        )}
                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            {this.controlRenderer.renderCheckbox(
                                "ObstetricalFile_InfluenzaDiscussedLabel",
                                recomended.IsInfluenzaDiscussed,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.IsInfluenzaDiscussed = value),
                                "col-md-12",
                                "text-bold"
                            )}
                        </div>
                        <div className="row">
                            <div className="col-md-12 flex-display">
                                {this.controlRenderer.renderCheckbox(
                                    "ReceivedLabel",
                                    recomended.IsInfluenzaVaccineReceived,
                                    value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.IsInfluenzaVaccineReceived = value),
                                    "",
                                    "text-bold"
                                )}
                                {this.controlRenderer.renderCheckbox(
                                    "DeclinedLabel",
                                    recomended.IsInfluenzaVaccineDeclined,
                                    value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.IsInfluenzaVaccineDeclined = value),
                                    "margin-xl-left",
                                    "text-bold"
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        {this.controlRenderer.renderCheckbox(
                            "ObstetricalFile_PertussisDiscussedLabel",
                            recomended.IsPertussisDiscussed,
                            value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.IsPertussisDiscussed = value),
                            "",
                            "text-bold"
                        )}
                        <div className="row">
                            <div className="col-md-12 flex-display margin-sm-bottom">
                                <div style={{ width: "90px" }}>
                                    {this.renderRadioButtonField(
                                        "ObstetricalFile_UpToDateLabel",
                                        this.controlRenderer.renderInlineYesNoRadio(
                                            recomended.IsPertussisUpToDate,
                                            value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.IsPertussisUpToDate = value),
                                            "RecommendedImmuniprophylaxis_IsPertussisUpToDate",
                                            ""
                                        )
                                    )}
                                </div>
                                {this.renderSimpleField(
                                    "SingularYearLabel",
                                    this.controlRenderer.renderTextbox({
                                        value: recomended.PertussisUpdateYear?.toString(),
                                        onChange: value => this.props.mutateModelState(s => s.Opr3.RecommendedImmuniprophylaxis.PertussisUpdateYear = value && Number(value)),
                                        maxLength: 4,
                                        isInteger: true
                                    }),
                                    "margin-xl-left"
                                )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 flex-display">
                                <div style={{ width: "90px" }}>
                                    {this.controlRenderer.renderCheckbox(
                                        "ReceivedLabel",
                                        recomended.IsPertussisVaccineReceived,
                                        value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.IsPertussisVaccineReceived = value),
                                        "",
                                        "text-bold"
                                    )}
                                </div>
                                {this.controlRenderer.renderCheckbox(
                                    "DeclinedLabel",
                                    recomended.IsPertussisVaccineDeclined,
                                    value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.IsPertussisVaccineDeclined = value),
                                    "margin-xl-left",
                                    "text-bold"
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="row">
                            <div className="col-md-12">
                                <p className="text-bold">{this.getString("ObstetricalFile_PostpartumVaccineDiscussedLabel")}</p>
                            </div>
                        </div>
                        <div className="row">
                            {this.controlRenderer.renderCheckbox(
                                "QuebecVaccinationRegistry_Values_Agent_386013003",
                                recomended.IsRubellaPostPartumVaccineDiscussed,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.IsRubellaPostPartumVaccineDiscussed = value),
                                "col-md-12",
                                "text-bold"
                            )}
                        </div>
                        <div className="row">
                            {this.controlRenderer.renderCheckbox(
                                "OtherLabel",
                                recomended.IsOtherPostPartumVaccineDiscussed,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.IsOtherPostPartumVaccineDiscussed = value),
                                "col-md-12",
                                "text-bold"
                            )}
                        </div>
                        {this.controlRenderer.renderTextbox({
                            value: recomended.OtherPostPartumVaccineDiscussed,
                            onChange: value => this.props.mutateModelState(s => s.Opr3.RecommendedImmuniprophylaxis.OtherPostPartumVaccineDiscussed = value),
                            maxLength: OntarioObstetricalFileFieldLimits.Page3.RecommendedImmuniprophylaxis_OtherPostPartumVaccineDiscussed.MaxChars,
                            id: otherPostPartumVaccineDiscussedId,
                            clickableTextOptions: this.getClickableTextOptions(otherPostPartumVaccineDiscussedId, OntarioObstetricalFileClickableTextContext.Opr3_RecommendedImmuniprophylaxisOtherVaccineDiscussed)
                        })}
                    </div>
                    <div className="col-md-2">
                        <div className="row">
                            <div className="col-md-12">
                                <p className="text-bold">{this.getString("ObstetricalFile_NewbornNeedsLabel")}</p>
                            </div>
                        </div>
                        <div className="row">
                            {this.controlRenderer.renderCheckbox(
                                "ObstetricalFile_HepBProphylaxisLabel",
                                recomended.IsHepBProphylaxisNeededForNewBorn,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.IsHepBProphylaxisNeededForNewBorn = value),
                                "col-md-12",
                                "text-bold"
                            )}
                        </div>
                        <div className="row">
                            {this.controlRenderer.renderCheckbox(
                                "ObstetricalFile_HIVProphylaxisLabel",
                                recomended.IsHivProphylaxisNeededForNewBorn,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Opr3.RecommendedImmuniprophylaxis.IsHivProphylaxisNeededForNewBorn = value),
                                "col-md-12",
                                "text-bold"
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { OntarioObstetricalFileRecommendedImmuniprophylaxis };
